import {SensorValue} from '../rest'
import {User} from '../state'
import {FilterOptions} from '../tasks/effects'

export enum AlarmType {
  Temperature = 'TEMPERATURE',
  Humidity = 'HUMIDITY',
  Cooling = 'COOLING',
  Disconnect = 'DISCONNECT',
  Calibration = 'CALIBRATION',
  Battery = 'BATTERY',
  Waste = 'WASTE',
  Hygiene = 'HYGIENE',
  Manual = 'MANUAL',
  SensorMalfunction = 'SENSOR' // Not used
}

export enum AlarmSubType {
  High = 'HIGH',
  Low = 'LOW',
  CoolingTime = 'COOLINGTIME'
}

export interface AlarmResolveFilters {
  alarmTypes?: string[]
  from?: string
  to?: string
  hasImage?: string
}

export interface Alarm {
  category: 'task' | 'equipment'
  id: string
  status: string
  name: string
  triggeredTime: string
  createdAt?: string
  resolvedTime: string
  measuredValue: number
  reason: string
  type: AlarmType
  subtype: AlarmSubType
  completedBy: string
  duration: number
  note: string | null
  measurementTarget: string | null
  targetDay: string // for calibration expired
  limits: {
    minValue: number
    maxValue: number
  } | null
  sensorRole: string | null
  unit: string | null
  endedAtTime: string | null
  isResolvable: boolean
  applianceId: string | null
  applianceType: string | null
  taskId: string | null
  taskType: string | null
  latestValue: SensorValue | null
  resolvedBy: string
  actor: User | null
  followupTaskCreated: boolean | null
  assets?: import('../rest').AssetData[]
}

export type CycleLogAlarm = {
  id: string
  createdAt: string
  startedAt: string
  endedAt?: string
  firstMeasurement: number
  lastMeasurement: number
  startLimit: number
  targetLimit: number
  alarmThreshold: number
  alarmValue: number
  alarmType: AlarmSubType
  reason?: string
  resolution?: string
  resolvedAt?: string
  resolvedBy?: string
  type?: string
}

export interface AlarmsState {
  query: {siteId: string; options: FilterOptions} | null
  filters: {
    alarmTypes: string[] // {id: string; name: string}[]
    completedBy: {id: string; name: string}[]
  }
  allAlarms: Alarm[]
  applianceAlarms: Alarm[]
  activeTaskAlarmsCount: number
  activeApplianceAlarmsCount: number
  taskAlarmsCount: number
  applianceAlarmsCount: number
  taskAlarms: Alarm[]
  loading: boolean
  loadingMoreData: boolean
  error: Error | null
}

export const state: AlarmsState = {
  query: null,
  filters: {
    alarmTypes: [],
    completedBy: []
  },
  allAlarms: [],
  applianceAlarms: [],
  taskAlarms: [],
  activeTaskAlarmsCount: 0,
  activeApplianceAlarmsCount: 0,
  taskAlarmsCount: 0,
  applianceAlarmsCount: 0,
  loading: false,
  loadingMoreData: false,
  error: null
}
